import React from 'react';

const History = () => {
    return (
        <div>
            <h1 className="my-10">No History</h1>
        </div>
    );
};

export default History;